<template>
  <q-page class="q-pa-md bg-grey-2">
    <!-- NAVEGACIÓN Y BREADCRUMBS -->
    <div class="row items-center justify-between q-mb-md wrap gap-sm">
      <q-breadcrumbs active-color="primary" style="font-size: 14px" class="q-py-xs">
        <q-breadcrumbs-el label="Inicio" icon="home" to="/aveo/Dashboard" />
        <q-breadcrumbs-el label="Empresas" icon="business" />
        <q-breadcrumbs-el label="Listado General" icon="list" />
      </q-breadcrumbs>

      <div class="row q-gutter-sm items-center">
        <q-btn
          outline
          color="primary"
          icon="dashboard"
          label="Dashboard"
          no-caps
          class="bg-white"
          @click="$router.push('/aveo/Dashboard')"
        />
        <q-btn
          color="primary"
          icon="add"
          label="Nueva Empresa"
          no-caps
          unelevated
          class="text-weight-bold"
          @click="AbrirNuevaEmpresa"
        />
      </div>
    </div>

    <!-- Banner Principal -->
    <q-card class="q-mb-md shadow-2 rounded-borders overflow-hidden">
      <div class="bg-primary text-white q-pa-md row items-center justify-between wrap">
        <div class="row items-center q-py-xs">
          <q-avatar color="white" text-color="primary" size="42px" class="q-mr-md shadow-1">
            <q-icon name="business" size="sm" />
          </q-avatar>
          <div>
            <div class="text-h6 text-weight-bold">Gestión de Empresas</div>
            <div class="text-caption text-blue-2">Listado general, selección múltiple y administración por lote</div>
          </div>
        </div>

        <!-- Badges informativos de resumen -->
        <div class="row q-gutter-xs q-py-xs">
          <q-chip color="white" text-color="positive" class="text-weight-bold">
            <q-icon name="check_circle" class="q-mr-xs" size="xs" />
            {{ conteoVigentes }} Vigentes
          </q-chip>
          <q-chip color="white" text-color="negative" class="text-weight-bold">
            <q-icon name="cancel" class="q-mr-xs" size="xs" />
            {{ conteoAnulados }} Anulados
          </q-chip>
        </div>
      </div>

      <!-- Filtro de Búsqueda y Estado -->
      <q-card-section class="q-pa-md bg-white">
        <div class="row q-col-gutter-md items-center">
          <div class="col-12 col-sm-6 col-md-6">
            <q-input
              v-model="Buscar1"
              outlined
              dense
              placeholder="Buscar por RUC o Razón Social..."
              clearable
              @keyup.enter="BuscarProducto"
            >
              <template v-slot:prepend>
                <q-icon name="search" />
              </template>
            </q-input>
          </div>

          <!-- Filtro de Estado: Vigentes (V), Anulados (A) o Todos -->
          <div class="col-12 col-sm-4 col-md-4">
            <q-select
              v-model="filtroEstado"
              :options="opcionesEstado"
              option-value="value"
              option-label="label"
              emit-value
              map-options
              outlined
              dense
              label="Filtrar por Estado"
              @input="BuscarProducto"
            >
              <template v-slot:prepend>
                <q-icon name="filter_alt" color="primary" />
              </template>
            </q-select>
          </div>

          <div class="col-12 col-sm-2 col-md-2">
            <q-btn
              color="primary"
              icon="search"
              label="Buscar"
              no-caps
              class="full-width text-weight-bold"
              unelevated
              @click="BuscarProducto"
            />
          </div>
        </div>
      </q-card-section>
    </q-card>

    <!-- Banner de Acciones Masivas (Aparece cuando hay empresas seleccionadas) -->
    <q-card v-if="selectedEmpresas.length > 0" class="q-mb-md bg-indigo-1 text-indigo-9 shadow-3 rounded-borders border-indigo">
      <q-card-section class="q-py-sm">
        <div class="row items-center justify-between wrap">
          <div class="row items-center q-mr-md q-py-xs">
            <q-avatar color="indigo" text-color="white" icon="playlist_add_check" size="36px" class="q-mr-sm" />
            <div>
              <div class="text-subtitle1 text-weight-bolder">
                {{ selectedEmpresas.length }} empresa(s) seleccionada(s)
              </div>
              <div class="text-caption text-grey-8">
                Selecciona una acción para aplicar a todas las empresas marcadas simultáneamente
              </div>
            </div>
          </div>

          <div class="row q-gutter-xs q-mt-xs-sm items-center">
            <q-btn
              color="positive"
              icon="check_circle"
              label="Dar de ALTA Masivo (Vigente)"
              no-caps
              unelevated
              class="text-weight-bold"
              @click="CambiarEstadoMasivoConfirm('V')"
            />
            <q-btn
              color="negative"
              icon="cancel"
              label="Dar de BAJA Masivo (Anular)"
              no-caps
              unelevated
              class="text-weight-bold"
              @click="CambiarEstadoMasivoConfirm('A')"
            />
            <q-btn
              flat
              color="grey-8"
              icon="close"
              label="Deseleccionar"
              no-caps
              @click="selectedEmpresas = []"
            />
          </div>
        </div>
      </q-card-section>
    </q-card>

    <!-- Tabla Quasar con Selección Múltiple -->
    <q-card class="shadow-2 rounded-borders">
      <q-table
        :data="ListaArticulos"
        :columns="columns"
        row-key="ruc"
        selection="multiple"
        :selected.sync="selectedEmpresas"
        :grid="$q.screen.xs"
        :pagination.sync="pagination"
        flat
        bordered
        no-data-label="No se encontraron empresas registradas para el filtro seleccionado"
      >
        <!-- Slot Grid para Móviles (Pantallas Celular) -->
        <template v-slot:item="props">
          <div class="q-pa-xs col-xs-12 col-sm-6 col-md-4">
            <q-card class="shadow-2 rounded-borders overflow-hidden" :class="props.selected ? 'bg-blue-1' : ''">
              <!-- Encabezado de la Tarjeta Móvil -->
              <q-card-section class="bg-grey-1 q-pa-sm row items-center justify-between">
                <div class="row items-center q-gutter-xs">
                  <q-checkbox v-model="props.selected" dense />
                  <div>
                    <div class="text-subtitle1 text-weight-bold text-primary">{{ props.row.razonsocial }}</div>
                    <div class="text-caption text-grey-7">RUC: <strong class="text-dark">{{ props.row.ruc }}</strong></div>
                  </div>
                </div>

                <q-chip
                  clickable
                  dense
                  :color="props.row.estado === 'V' ? 'positive' : 'negative'"
                  text-color="white"
                  class="text-weight-bold cursor-pointer"
                  style="font-size: 11px; padding: 2px 8px;"
                  @click="CambiarEstadoConfirm(props.row)"
                >
                  <q-icon
                    :name="props.row.estado === 'V' ? 'check_circle' : 'cancel'"
                    size="xs"
                    class="q-mr-xs"
                  />
                  {{ props.row.estado === 'V' ? 'VIGENTE' : 'BAJA' }}
                </q-chip>
              </q-card-section>

              <q-separator />

              <!-- Detalles en Tarjeta -->
              <q-card-section class="q-pa-sm text-caption text-grey-9">
                <div v-if="props.row.telefono" class="row items-center q-mb-xs">
                  <q-icon name="phone" color="primary" class="q-mr-xs" size="16px" />
                  <span><strong>Tel:</strong> <a :href="'tel:' + props.row.telefono" class="text-primary text-weight-bold" style="text-decoration: none;">{{ props.row.telefono }}</a></span>
                </div>
                <div v-if="props.row.email" class="row items-center q-mb-xs">
                  <q-icon name="email" color="primary" class="q-mr-xs" size="16px" />
                  <span class="ellipsis"><strong>Email:</strong> {{ props.row.email }}</span>
                </div>
                <div v-if="props.row.direccion" class="row items-start">
                  <q-icon name="place" color="primary" class="q-mr-xs q-mt-xs" size="16px" />
                  <span><strong>Dir:</strong> {{ props.row.direccion }}</span>
                </div>
              </q-card-section>

              <q-separator />

              <!-- Acciones Táctiles Destacadas en Celular -->
              <q-card-actions class="row q-col-gutter-xs justify-end bg-grey-2 q-pa-xs">
                <div class="col-6">
                  <q-btn
                    outline
                    color="primary"
                    icon="edit"
                    label="Editar"
                    no-caps
                    dense
                    class="full-width text-weight-bold bg-white"
                    @click="Editar(props.row.ruc)"
                  />
                </div>
                <div class="col-6">
                  <q-btn
                    unelevated
                    color="warning"
                    text-color="dark"
                    icon="visibility"
                    label="Ver Detalle"
                    no-caps
                    dense
                    class="full-width text-weight-bold"
                    @click="Detalle(props.row.ruc)"
                  />
                </div>
              </q-card-actions>
            </q-card>
          </div>
        </template>

        <!-- Columna Estado (Chip interactivo para vista Escritorio) -->
        <template v-slot:body-cell-estado="props">
          <q-td :props="props" class="text-center">
            <q-chip
              clickable
              dense
              :color="props.row.estado === 'V' ? 'positive' : 'negative'"
              text-color="white"
              class="text-weight-bold cursor-pointer"
              style="font-size: 12px; padding: 2px 10px;"
              @click="CambiarEstadoConfirm(props.row)"
            >
              <q-icon
                :name="props.row.estado === 'V' ? 'check_circle' : 'cancel'"
                size="xs"
                class="q-mr-xs"
              />
              {{ props.row.estado === 'V' ? 'VIGENTE' : 'BAJA' }}
            </q-chip>
          </q-td>
        </template>

        <!-- Columna Acciones (Vista Escritorio) -->
        <template v-slot:body-cell-actions="props">
          <q-td :props="props" class="text-right">
            <q-btn
              flat
              round
              dense
              color="primary"
              icon="edit"
              @click="Editar(props.row.ruc)"
            >
              <q-tooltip>Editar Empresa</q-tooltip>
            </q-btn>
            <q-btn
              flat
              round
              dense
              color="warning"
              icon="visibility"
              @click="Detalle(props.row.ruc)"
            >
              <q-tooltip>Ver Detalle</q-tooltip>
            </q-btn>
          </q-td>
        </template>
      </q-table>
    </q-card>
  </q-page>
</template>

<script>
import axios from "axios";

export default {
  name: "EmpresaListaPage",
  data() {
    return {
      pagination: { rowsPerPage: 50 },
      NumerosPaginas: 1,
      TotalPaginas: 0,
      TamanoPagina: 50,
      Buscar1: "",
      filtroEstado: "V", // Default: Solo Vigentes
      opcionesEstado: [
        { label: "Solo Vigentes (V)", value: "V" },
        { label: "Anulados / Baja (A)", value: "A" },
        { label: "Todos los Registros", value: "TODOS" },
      ],
      ListaArticulos: [],
      selectedEmpresas: [], // Lista de empresas seleccionadas mediante checkboxes
      columns: [
        { name: "ruc", label: "RUC", field: "ruc", align: "left", sortable: true },
        { name: "razonsocial", label: "Razón Social", field: "razonsocial", align: "left", sortable: true },
        { name: "telefono", label: "Teléfono", field: "telefono", align: "left" },
        { name: "direccion", label: "Dirección", field: "direccion", align: "left" },
        { name: "email", label: "Email", field: "email", align: "left" },
        { name: "estado", label: "Estado", field: "estado", align: "center", sortable: true },
        { name: "actions", label: "Acciones", field: "actions", align: "right" },
      ],
    };
  },
  computed: {
    conteoVigentes() {
      return this.ListaArticulos.filter(x => x.estado === "V").length;
    },
    conteoAnulados() {
      return this.ListaArticulos.filter(x => x.estado === "A").length;
    },
  },
  created() {
    this.BuscarProducto();
  },
  methods: {
    Editar(ruc) {
      this.$router.push("/aveo/Empresa/Nuevo/" + ruc);
    },
    Detalle(ruc) {
      this.$router.push("/aveo/Empresa/Detalle/" + ruc);
    },
    AbrirNuevaEmpresa() {
      this.$router.push("/aveo/Empresa/Nuevo");
    },
    BuscarProducto() {
      let me = this;
      me.selectedEmpresas = []; // Limpiar selección al buscar
      axios({
        method: "post",
        url: "ApiWeb/EmpresaLista.php",
        data: {
          Buscar1: me.Buscar1,
          ruc: me.Buscar1,
          razonsocial: me.Buscar1,
          estado: me.filtroEstado,
        },
      })
        .then(function(response) {
          me.ListaArticulos = response.data.data || [];
          me.TotalPaginas = response.data.totalRegistros || 0;
          me.TamanoPagina = response.data.tamanoPagina || 50;
        })
        .catch(function(error) {
          console.error("Error al obtener listado de empresas:", error);
        });
    },
    // Cambio individual de estado
    CambiarEstadoConfirm(row) {
      const nuevoEstado = row.estado === "V" ? "A" : "V";
      const accionTexto = nuevoEstado === "V" ? "Dar de ALTA (Vigente)" : "Dar de BAJA (Anular)";

      this.$q.dialog({
        title: "Confirmar Cambio de Estado",
        message: `¿Desea cambiar el estado de la empresa <strong>${row.razonsocial}</strong> (RUC: ${row.ruc}) a <strong>${accionTexto}</strong>?`,
        html: true,
        cancel: true,
        persistent: true,
        ok: {
          label: "Sí, Cambiar",
          color: nuevoEstado === "V" ? "positive" : "negative",
        },
      }).onOk(() => {
        this.ActualizarEstadoEmpresa(row.ruc, nuevoEstado);
      });
    },
    ActualizarEstadoEmpresa(ruc, estado) {
      let me = this;
      axios
        .post("ApiWeb/EmpresaCambiarEstado.php", {
          ruc: ruc,
          estado: estado,
        })
        .then((response) => {
          if (response.data && !response.data.error) {
            if (me.$q && me.$q.notify) {
              me.$q.notify({
                message: response.data.mensaje || "Estado actualizado",
                color: "positive",
                icon: "check_circle",
              });
            }
            me.BuscarProducto();
          } else {
            if (me.$q && me.$q.notify) {
              me.$q.notify({
                message: "Error al actualizar estado",
                color: "negative",
                icon: "warning",
              });
            }
          }
        })
        .catch((error) => {
          console.error("Error al actualizar estado:", error);
        });
    },
    // Cambio masivo para múltiples empresas seleccionadas
    CambiarEstadoMasivoConfirm(nuevoEstado) {
      if (this.selectedEmpresas.length === 0) return;

      const cantidad = this.selectedEmpresas.length;
      const accionTexto = nuevoEstado === "V" ? "Dar de ALTA (VIGENTE)" : "Dar de BAJA (ANULAR)";
      const rucs = this.selectedEmpresas.map(row => row.ruc);

      this.$q.dialog({
        title: "Confirmar Cambio de Estado Masivo",
        message: `¿Está seguro de cambiar el estado de <strong>${cantidad} empresa(s)</strong> seleccionada(s) a <strong>${accionTexto}</strong>?`,
        html: true,
        cancel: true,
        persistent: true,
        ok: {
          label: `Sí, aplicar a las ${cantidad} empresas`,
          color: nuevoEstado === "V" ? "positive" : "negative",
        },
      }).onOk(() => {
        this.ActualizarEstadoMasivo(rucs, nuevoEstado);
      });
    },
    ActualizarEstadoMasivo(rucs, estado) {
      let me = this;
      axios
        .post("ApiWeb/EmpresaCambiarEstado.php", {
          rucs: rucs,
          estado: estado,
        })
        .then((response) => {
          if (response.data && !response.data.error) {
            if (me.$q && me.$q.notify) {
              me.$q.notify({
                message: response.data.mensaje || `Estado actualizado para ${rucs.length} empresas`,
                color: "positive",
                icon: "check_circle",
              });
            }
            me.selectedEmpresas = [];
            me.BuscarProducto();
          } else {
            if (me.$q && me.$q.notify) {
              me.$q.notify({
                message: "Error al actualizar estados masivos",
                color: "negative",
                icon: "warning",
              });
            }
          }
        })
        .catch((error) => {
          console.error("Error al actualizar estados masivos:", error);
        });
    },
  },
};
</script>
